import { render, staticRenderFns } from "./ArtiklBrowse.vue?vue&type=template&id=48bfe249"
import script from "./ArtiklBrowse.vue?vue&type=script&lang=js"
export * from "./ArtiklBrowse.vue?vue&type=script&lang=js"
import style0 from "./ArtiklBrowse.vue?vue&type=style&index=0&id=48bfe249&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports